import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout-only: gives the draft editor a "Draft orders" crumb that links back to the list. */
export const Route = createFileRoute('/_authed/_active/s/$storeId/draft-orders')({
  staticData: { crumb: 'common:nav.draftOrders' },
  component: Outlet,
});
